import React from 'react';
import { Text } from '@fluentui/react-components';
import { useErrorComponentStyles } from './ErrorComponent.styles';
import { IErrorComponentProps } from './ErrorComponent.types';
/**
 * Error component with title and description
 */
export const ErrorComponent = (props: IErrorComponentProps) => {
  let { title, description } = props;
  const styles = useErrorComponentStyles();

  title = title || 'Something went wrong';

  return (
    <div className={styles.container}>
      <Text weight="bold" className={styles.titleContainer}>
        {title}
      </Text>
      {description && (
        <Text size={400} className={styles.descContainer}>
          {description}
        </Text>
      )}
    </div>
  );
};
